import Reminder from "./components/layouts/Reminder";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./components/accounts/Register";
import Login from "./components/accounts/Login";
import { AuthProvider } from "./contexts/AuthContext";
import WithPrivateRoute from "./utils/WithPrivateRoute";
import ErrorMessage from "./components/layouts/ErrorMessage";
import TodoPage from "./components/layouts/Todo"
import Header from "./components/layouts/Header";
function App() {
  return (
    <AuthProvider>
      <Router>
        <Header/>
        <ErrorMessage />
        <Routes>
          <Route exact path="" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route
            exact
            path="/reminder"
            element={
              <WithPrivateRoute>
                <Reminder />
              </WithPrivateRoute>
            }
          />
          <Route
            exact
            path="/todo"
            element={
              <WithPrivateRoute>
                <TodoPage />
              </WithPrivateRoute>
            }
          />
          </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
